import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();

export const GetT_HardwareByPage = params => { return axios.get(`${base}/api/HardWare/GetT_HardwareByPage`, { params: params }); };

//状态
export const MAP_STATUS_LIST = [{ id: '-1', text: '全部' }, { id: '0', text: '未绑定' }, { id: '1', text: '已绑定' }, { id: '2', text: '解绑' }, { id: '9', text: '作废' }, { id: '99', text: '已锁定' }];
//尺寸
export const MAP_SIZE_LIST = [{ id: '0', text: '电视55寸' }, { id: '1', text: '电视65寸' }, { id: '2', text: '电视100寸' }];




// WEBPACK FOOTER //
// ./src/api/hardWareApi.js